import { render, staticRenderFns } from "./RadioCardList.vue?vue&type=template&id=12f53e6e"
import script from "./RadioCardList.vue?vue&type=script&lang=js"
export * from "./RadioCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports